<template>
    <MultiSelectWithIconsBaseDropdown v-bind="$props" v-on="$listeners"
                                      :uniqueId="uniqueId"
                                      :searchEnabled="false"
                                      firstSelectedAsCount
                                      :givenSearchedText.sync="searchText"
                                      :options="sortedOptions"
                                      small
                                      showSelectAll
                                      @closeMenu="closeMenu">
        <template #dropdownField="dropdownProps" class="dropdown-field">
            <div :class="{'closed-dropdown-field': !isMenuOpened, 'opened-dropdown-field': isMenuOpened }"
                 @click="openMenu">
                <LabelInput :label="label"
                               :placeholder="searchPlaceholder"
                               :class="{'disabled': isDisable}"
                               ref="searchInput"
                               :isDisable="isDisable"
                               :uniqueId="uniqueId"
                               v-model="searchText">
                    <template #inputValue class="slot-input">
                        <span v-if="!isMenuOpened">
                            {{ dropdownProps.dropdownFieldTitle || input }}
                        </span>
                    </template>
                    <template #inputIcon>
                        <span class="input-icon">
                            <IconBase
                                v-show="isMenuOpened"
                                :width="iconData.width"
                                :height="iconData.height"
                                :iconName="iconData.name"
                                :iconColor="iconData.color"
                                verticalAlign="middle"
                                key="searchIcon"
                                id="searchIcon"
                                :class="{'clickable': isSearchActive}"
                                @click.stop.native="onIconClick"
                            />
                            <IconBase :width="7"
                                      :height="8"
                                      iconName="menuIcon"
                                      key="menuIcon"
                                      id="menuIcon"
                                      v-show="!isMenuOpened && !isDisable"
                                      :iconColor="consts.COLORS.LIGHT_700"
                                      verticalAlign="middle"
                            />
                        </span>
                    </template>
                </LabelInput>
            </div>
        </template>
    </MultiSelectWithIconsBaseDropdown>
</template>

<script>
import MultiSelectWithIconsBaseDropdown from 'components/dropdowns/MultiSelectWithIconsBaseDropdown.vue';
import IconBase from 'components/IconBase.vue';
import consts from 'services/metaData/consts';
import LabelInput from '../inputs/LabelInput.vue';

export default {
    name: 'FromInputMultiSelectDropdown',
    components: {
        MultiSelectWithIconsBaseDropdown,
        LabelInput,
        IconBase
    },
    props: {
        ...MultiSelectWithIconsBaseDropdown.props,
        label: String
    },
    data() {
        return {
            searchText: '',
            consts,
            isMenuOpened: false,
            sortedOptions: []
        };
    },
    methods: {
        openMenu() {
            if (this.isDisable) { return; }
            this.isMenuOpened = true;
            this.$refs.searchInput.focus();
            this.$emit('openMenu');
        },
        closeMenu() {
            this.searchText = '';
            this.isMenuOpened = false;
        },
        sortOptions() {
            this.sortedOptions = this.options.slice();
            const sortedSelectedIds = this.selectedIds.slice();
            const {
                idField,
                displayField,
                sortedOptions
            } = this;
            if (this.sortedOptions && this.sortedOptions[0] && !this.sortedOptions[0].isSelectAll) {
                this.sortedOptions.unshift({
                    [this.displayField]: 'Select all',
                    [this.idField]: 'selectAll',
                    isSelectAll: true
                });
            }
            sortedSelectedIds.sort((a, b) => {
                const bId = sortedOptions[sortedOptions.findIndex((x) => x[idField] === b)][displayField];
                const aId = sortedOptions[sortedOptions.findIndex((x) => x[idField] === a)][displayField];
                if (bId.toLowerCase() > aId.toLowerCase()) { return 1; }
                if (bId.toLowerCase() < aId.toLowerCase()) { return -1; }
                return 0;
            });
            this.sortedOptions.sort((a, b) => {
                if (a.isSelectAll || b.isSelectAll) { return 1; }
                if (sortedSelectedIds.indexOf(b[idField]) > sortedSelectedIds.indexOf(a[idField])) { return 1; }
                if (sortedSelectedIds.indexOf(a[idField]) > sortedSelectedIds.indexOf(b[idField])) { return -1; }
                if (a[displayField].toLowerCase() > b[displayField].toLowerCase()) { return 1; }
                if (a[displayField].toLowerCase() < b[displayField].toLowerCase()) { return -1; }
                return 0;
            });
        },
        onIconClick() {
            if (this.isSearchActive) {
                this.searchText = '';
                this.$refs.searchInput.focus();
            }
        },
        input(data) {
            return data[0] || 'None';
        }
    },
    computed: {
        noSearchResults() {
            return this.sortedOptions.length === 1;
        },
        isSearchActive() {
            return this.isMenuOpened && this.searchText.length > 0;
        },
        iconData() {
            const iconData = {
                width: 10,
                height: 10,
                color: consts.COLORS.LIGHT_700
            };
            if (this.isMenuOpened) {
                if (this.isSearchActive) {
                    iconData.name = 'clearFullCircleIcon';
                } else {
                    iconData.name = 'searchIcon';
                }
            }

            return iconData;
        },
        searchPlaceholder() {
            return this.selectedIds.length ? `${this.selectedIds.length} Selected` : 'Search';
        }
    },
    watch: {
        options: {
            immediate: true,
            handler() {
                this.sortOptions();
            }
        }
    }
};
</script>
<style scoped lang="scss">
@import "~styles/styleGuide.scss";

.closed-dropdown-field {
    cursor: pointer;
    width: 213px;
    .disabled {
        cursor: default;
        color: $light-700;
    }
}

.opened-dropdown-field {
    width: 396px;
    transition: width 0.25s ease-out;
    height: 32px;
}

.input-wrapper {
    overflow: hidden;
}

.input-icon {
    text-align: center;
    position: absolute;
    top: 5px;
    right: 12px;
    color: $light-900;
}

.clickable {
    cursor: pointer;
}

::v-deep .input-value {
        width: 70%;
}

::v-deep .dropdown-area {
    max-width: 395px;

    ul {
        padding: 4px;

        .preset-element {
            border-radius: 4px;
            &:hover {
                background-color: $light-200;
            }

            input[type=checkbox] {
                height: 14px;
            }
        }

        .small label {
            line-height: 32px;
        }
    }
}

</style>
